import { gql } from '@src/lib/gql'

/** Seat wizard create/edit preload (ADV-G3). */
export const CREATE_SEAT_ENGAGEMENT = gql`
  query CreateSeatSectionEngagement($advisorEngagementId: String!) {
    advisorEngagement(advisorEngagementId: $advisorEngagementId) {
      id
      advisorEngagementId
      categoryKey
      industryKeys
      skillTagTitles
      whyText
      timeCommitmentNotes
      timeCommitmentTypeKeys
      compensationTypeKeys
      notifyMatches
      currentUserCanEdit
      category {
        id
        key
        title
      }
    }
  }
`
